import React, { useState, useEffect } from 'react';
import { appliedRuleIcon, restartIcon } from "../../assets/images";
import { formatter, validate } from "../../utility";
import { CustomDateInput, InputBase } from "../Helper/InputBase";
import { Button } from 'react-bootstrap';
import appConstants from '../../config/app_config';
import moment from 'moment';
import GeneralUtils from '../../utility/GeneralUtils';

const DROPDOWN_YES_VALUE = '1';
const DROPDOWN_NO_VALUE = '0';

const RICalcStepOne = (props) => {
  const { 
    phase1RentIncreaseDate, calc_p1RemainingEligibleAmount, phase1RentAmountUsed, phase1RentAmount, 
    calc_p1IsRemainingEligibleAmountValid, userAccessDate, address, rentAmountError
  } = props?.phaseOneData;

  const {
    calc_p2EarliestRentIncreaseDate,
    stepOneSubmitted,
    calc_p2EarliestServiceDate,
    calc_p2MaxRentIncreaseDate
  } = props?.phaseTwoData;

  const [stepOneData, setStepOneData] = useState({
    rentIncreaseDateAfterPhase2: props?.phaseTwoData?.rentIncreaseDateAfterPhase2 || '',
    isRentIncreaseAfterPhase2: props?.phaseTwoData?.isRentIncreaseAfterPhase2 === true ? DROPDOWN_YES_VALUE : props?.phaseTwoData?.isRentIncreaseAfterPhase2 === false ? DROPDOWN_NO_VALUE : '',
    errors: {}
  });

  const hideRentIncreaseDateAfterPhase2Question = moment(calc_p2EarliestRentIncreaseDate).isAfter(moment()) && !appConstants.testMode;

  useEffect(() => {
    if (hideRentIncreaseDateAfterPhase2Question) {
      setStepOneData({...stepOneData, isRentIncreaseAfterPhase2: DROPDOWN_NO_VALUE, errors: { ...stepOneData?.errors, [isRentIncreaseAfterPhase2]: '' }});
      submitStepOne();
    }
  },[])

  const handleSelectChange = (event) => {
    const { name, value } = event.target;
    setStepOneData({...stepOneData, [name]: value, errors: {}});
  }

  const handleDateChange = (value, event) => {
    const { name } = event;
    setStepOneData({...stepOneData, [name]: value, errors: { ...stepOneData?.errors, [name]: '' }})
  }

  const calculateStepOneVars = () => {
    const getCalcRentIncreaseServiceTimeIsAvailable = (earliestServiceDate, maxRentIncreaseDate) => {
      if (!earliestServiceDate || !maxRentIncreaseDate || !maxRentIncreaseDate) return false;
      return moment(earliestServiceDate).isBefore(maxRentIncreaseDate);
    }
    const calc_p2IsServiceTimeAvailable = getCalcRentIncreaseServiceTimeIsAvailable(calc_p2EarliestServiceDate, calc_p2MaxRentIncreaseDate);

    const p2StepOneData = {
      calc_p2IsServiceTimeAvailable
    }
    
    GeneralUtils.log('----- PRINTING ALL PHASE 2 - STEP 1 CALC VARIABLES -----', 'success');
    GeneralUtils.log(`
      rentIncreaseDateAfterPhase2: ${rentIncreaseDateAfterPhase2}\n
      isRentIncreaseAfterPhase2: ${Boolean(isRentIncreaseAfterPhase2)}\n
      calc_p2IsServiceTimeAvailable: ${calc_p2IsServiceTimeAvailable}
    `, 'info');

    return p2StepOneData;
  }

  const submitStepOne = () => {
    const validations = [
      {
        isRentIncreaseAfterPhase2,
        validationRules: [{ isRequired: !hideRentIncreaseDateAfterPhase2Question, errorMsg: 'Answer is required' }],
      },
      {
        rentIncreaseDateAfterPhase2,
        validationRules: [{ isRequired: isRentIncreaseAfterPhase2 === DROPDOWN_YES_VALUE, errorMsg: 'Date is required' }],
      },
    ]
    
    const validationErrors = validate(validations);
    if (Object.keys(validationErrors).length) {
      setStepOneData({...stepOneData, errors: validationErrors });
    } else {
      if (isRentIncreaseAfterPhase2 === DROPDOWN_NO_VALUE) {
        setStepOneData({ ...stepOneData, ...{ rentIncreaseDateAfterPhase2: isRentIncreaseAfterPhase2 === DROPDOWN_NO_VALUE ? '' : rentIncreaseDateAfterPhase2 }})
      }

      const calculatedStepOneVars = calculateStepOneVars();
      let data = { ...stepOneData, ...{ isRentIncreaseAfterPhase2: isRentIncreaseAfterPhase2 === DROPDOWN_YES_VALUE,  rentIncreaseDateAfterPhase2: isRentIncreaseAfterPhase2 === DROPDOWN_NO_VALUE ? '' : rentIncreaseDateAfterPhase2}};
      props?.setPhaseTwoData({...props?.phaseTwoData, ...data, ...calculatedStepOneVars, ...{  stepOneSubmitted: true }});
    }
  }

  const modifyClicked = () => {
    props?.setPhaseTwoData({...props?.phaseTwoData, ...{  stepOneSubmitted: false, stepTwoSubmitted: false, stepThreeSubmitted: false }})
  }

  const { isRentIncreaseAfterPhase2, rentIncreaseDateAfterPhase2, errors } = stepOneData;
  
  return (
    <div className="ric__step-one">
      <div className="ric__step-one__info__wrapper">
        <div className="ric__step-one__info">
          <div className="ric__step-one__info__label">Rental unit address:</div>
          <div className="ric__step-one__info__value">{address}</div>
        </div>
        <div className="ric__step-one__info">
          <div className="ric__step-one__info__label">Phase 1 rent increase date:</div>
          <div className="ric__step-one__info__value">{formatter.toDateDisplay(phase1RentIncreaseDate, { fullMonth: true })}</div>
        </div>
        <div className="ric__step-one__info">
          <div className="ric__step-one__info__label">Rent amount after phase 1 rent increase:</div>
          <div className="ric__step-one__info__value">{formatter.toAmountDisplay(phase1RentAmountUsed, { fullMonth: true })} {rentAmountError ? <span className="ric__step-one__info__error">*potential error detected</span> : ''}</div>
        </div>
        <div className="ric__step-one__info">
          <div className="ric__step-one__info__label">Remaining eligible amount:</div>
          <div className="ric__step-one__info__value">{formatter.toAmountDisplay(calc_p1RemainingEligibleAmount, { fullMonth: true })} {!calc_p1IsRemainingEligibleAmountValid ? <span className="ric__step-one__info__error">*corrected</span> : ''}</div>
        </div>
        <div className="ric__step-one__info">
          <div className="ric__step-one__info__label">Date of rent increase calculation:</div>
          <div className="ric__step-one__info__value">{formatter.toDateDisplay(userAccessDate, { fullMonth: true })}</div>
        </div>
      </div>

      { !hideRentIncreaseDateAfterPhase2Question ? <p className="ric__rule">
        <img className="w1-step-three__rule__icon" src={appliedRuleIcon} alt='' />
        <span>
          <b>Applied Rule</b>: The second additional rent increase (phase 2) can only be imposed at least 12 months after the effective date of the first additional rent increase (phase 1).
          <span className="w1-step-three__rule--success">&nbsp;The earliest effective date allowed for the phase 2 rent increase is&nbsp;<b>{formatter.toDateDisplay(calc_p2EarliestRentIncreaseDate, { fullMonth: true })}</b>.</span>
        </span>
      </p> : null }

      <div className="decision-questions__input-wrapper">
        { hideRentIncreaseDateAfterPhase2Question ? null : 
        <InputBase
          name='isRentIncreaseAfterPhase2'
          disabled={stepOneSubmitted}
          cssClass='fri-questions__existing-rent-increase'
          errors={errors.isRentIncreaseAfterPhase2}
          type='select'
          value={isRentIncreaseAfterPhase2}
          label={`Have you already applied a rent increase to this unit on or after ${formatter.toDateDisplay(calc_p2EarliestRentIncreaseDate, { fullMonth: true })}?`}
          handleSelectChange={handleSelectChange}
          selectList={[ { text: 'No', value: DROPDOWN_NO_VALUE }, { text: 'Yes', value: DROPDOWN_YES_VALUE } ]}
        /> }
      </div>
      { isRentIncreaseAfterPhase2 === DROPDOWN_YES_VALUE ? <div className="decision-questions__input-wrapper">
        <CustomDateInput
          name='rentIncreaseDateAfterPhase2'
          disabled={stepOneSubmitted}
          value={rentIncreaseDateAfterPhase2}
          errors={errors.rentIncreaseDateAfterPhase2}
          cssClass='decision-questions__decisionDate'
          minDate={moment(calc_p2EarliestRentIncreaseDate).toDate()}
          maxDate={appConstants.testMode ? null : moment(userAccessDate).toDate()}
          label='What was the effective date of this rent increase?'
          handleChange={handleDateChange}
        />
      </div> : null }

      { !hideRentIncreaseDateAfterPhase2Question ? <div className="ric__buttons hide-print">
        <Button variant="success" onClick={() => submitStepOne()} disabled={stepOneSubmitted}>Continue</Button>
        { stepOneSubmitted ? <span className="w1-step-one__modify" onClick={() => modifyClicked()}><img src={restartIcon} alt=""/> Modify</span> : null }
      </div> : null }
    </div>
  );
}

export default RICalcStepOne;